/* eslint-disable react/no-danger */
import React from 'react';

import { Link } from 'gatsby';

import { IoIosArrowRoundForward } from 'react-icons/io';
import ImgHTML from '../ImgHTML';
import img from '../../../static/img/upraisal-technology2.png';

export default ({
  customColumnsText: { title, subtitle, list, additionalInfo }
}) => {
  return (
    <div className="container mb-5 mvp-box">
      <div className="row d-flex flex-column flex-md-row">
        <div className="col col-md-8">
          <h2 className="subtitle without bigger">{title}</h2>
          <div className="content">
            <p>{subtitle}</p>
          </div>
          <div
            className="col d-md-flex mt-2 text-justify justify-content-between text-format text-left"
            dangerouslySetInnerHTML={{
              __html: list
            }}
          />
          <div className="extra">{additionalInfo}</div>
        </div>
        <div className="col col-md-3 text-center img position-relative">
          <ImgHTML src={img} style={{ maxWidth: '16rem' }} />
          <Link
            to="/case-studies/event-platform-medtech/"
            className="box position-absolute bg-white"
          >
            <div className="text position-relative d-flex justify-content-center align-items-center">
              <div>
                Read MVP <br /> case study
              </div>
              <div>
                <IoIosArrowRoundForward />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
